<template>
  <section class="eva-page">
    <v-row>
      <v-col cols="12" offset="0" md="10" offset-md="1">

        <!-- Topo -->
        <div class="eva-top">
          <v-breadcrumbs
            large
            :items="crumbs"
            divider="/"
            class="pl-0 eva-breadcrumbs"
          />

          <div class="eva-titlebar">
            <div class="eva-title">
              <v-icon color="primary" class="mr-2">mdi-shield-sun</v-icon>
              <span class="primary--text">Gestão de Epis</span>
            </div>

          </div>
        </div>

        <!-- Card principal -->
        <v-card class="eva-card mt-6" elevation="10">
          <v-card-title class="eva-card__title primary white--text">
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="white">mdi-clipboard-text</v-icon>
              <span class="font-weight-bold">
                Gestão de Epis
              </span>
            </div>

            <v-spacer />

            <v-chip color="white" outlined class="eva-chip">
              <v-icon left small>mdi-format-list-bulleted</v-icon>
              {{ total }} registos
            </v-chip>
          </v-card-title>

          <v-card-text class="pt-6">
            <div style="position:relative">
              <v-data-table
                :headers="headers"
                :items="items"
                :server-items-length="total"
                :loading="loading"
                :footer-props="tableFooter"
                :options.sync="options"
                class="eva-table"
                locale="pt-pt"
              >
                <template v-slot:top>
                  <div class="d-flex align-center justify-space-between px-4 py-2">
                    <div class="text-subtitle-1 font-weight-bold">
                      Gestão de Epis
                    </div>

                    <v-btn class="primary" small @click="openAddEpiDialog">
                      <v-icon left>mdi-plus</v-icon>
                      Adicionar
                    </v-btn>
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-row>
                    <v-col cols="auto">
                      <IconView class="mr-2" @click="openEpisDialog(item)" />
                    </v-col>
                  </v-row>
                </template>

                <template v-slot:no-data>
                  <div class="pa-6 grey--text text--darken-1">
                    Sem resultados.
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>
    
    <EpisView
      ref="episView"
      :obras="obras"
      :users_list="users_list"
      :is_management="true"
      @load-table="searchEPIS"
    /> 

    <v-dialog v-model="episDialog" max-width="1100">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            EPIs — {{ (episDialogUser && episDialogUser.name) || "Utilizador" }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn text @click="episDialog = false">Fechar</v-btn>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-progress-linear v-if="episDialogLoading" indeterminate color="primary" class="mb-4" />

          <div v-else>
            <!-- DESKTOP / TABLET -->
            <v-simple-table class="d-none d-lg-block">
              <thead>
                <tr>
                  <th class="text-center">Data entrega</th>
                  <th class="text-center">Obra</th>
                  <th class="text-center">Equipamentos</th>
                  <th class="text-center">Sharepoint</th>
                  <th class="text-center">Ver</th>
                </tr>
              </thead>

              <tbody> 
                <tr v-for="(l, i) in episDialogItems" :key="i">
                  <td class="text-center">{{ getTableDate(l.data_entrega) }}</td>
                  <td class="text-center">{{ l.obra }}</td>
                  <td class="text-center">{{ l.equipments_count }}</td>
                  <td class="text-center">
                    <a v-if="l.sharepoint" :href="l.sharepoint" target="_blank" rel="noopener">Abrir</a>
                    <span v-else>—</span>
                  </td>
                  <td class="text-center">
                    <IconView @click="openEpiFormFromDialog(l)" />
                  </td>
                </tr>

                <tr v-if="!episDialogItems.length">
                  <td colspan="5" class="text-center grey--text py-6">Sem registos.</td>
                </tr>
              </tbody>
            </v-simple-table>

            <!-- MOBILE / ITERATOR -->
            <v-data-iterator
              :items="episDialogItems"
              :items-per-page="-1"
              hide-default-footer
              class="d-block d-lg-none"
            >
              <template v-slot:default="{ items }">
                <v-row>
                  <v-col v-for="(l, i) in items" :key="i" cols="12">
                    <v-card outlined class="mt-2">
                      <v-card-text>
                        <v-row>
                          <v-col cols="6" class="text-caption grey--text">Data entrega</v-col>
                          <v-col cols="6" class="text-right">{{ getTableDate(l.data_entrega) }}</v-col>

                          <v-col cols="6" class="text-caption grey--text">Obra</v-col>
                          <v-col cols="6" class="text-right">{{ l.obra }}</v-col>

                          <v-col cols="6" class="text-caption grey--text">Equipamentos</v-col>
                          <v-col cols="6" class="text-right">{{ l.equipments_count }}</v-col>

                          <v-col cols="6" class="text-caption grey--text">Sharepoint</v-col>
                          <v-col cols="6" class="text-right">
                            <a v-if="l.sharepoint" :href="l.sharepoint" target="_blank" rel="noopener">Abrir</a>
                            <span v-else>—</span>
                          </v-col>

                          <v-col cols="12" class="pt-4">
                            <v-row align="center" justify="center">
                              <v-col cols="auto">
                                <IconView @click="openEpiFormFromDialog(l)" />
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col v-if="!items.length" cols="12" class="text-center grey--text py-6">
                    Sem registos.
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </div>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog v-model="exitDialog" max-width="420">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Registar devolução</v-toolbar-title>
          <v-spacer />
          <v-btn text @click="exitDialog = false">Fechar</v-btn>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-menu
            v-model="exitMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="exitFields.data_devolucao"
                label="Data devolução"
                outlined
                dense
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>

            <v-date-picker
              v-model="exitFields.data_devolucao"
              @input="exitMenu = false"
              :allowed-dates="(date) => date <= new Date(new Date() + 1).toISOString().substr(0,10)"
            />
          </v-menu>
        </v-card-text>

        <v-card-actions class="px-4 pb-4">
          <v-spacer />
          <v-btn class="success" :loading="exitLoading" :disabled="!exitFields.data_devolucao" @click="saveExitFromDialog">
            Gravar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    
  </section>
</template>

<script>
/*
  ODC-508 - Erbi Silva - 2026-02-06
  Adicionei a janela das Epis para o utilizador, onde é possível ver os epis que lhe foram entregues, e registar a devolução dos mesmos. Também adicionei um botão para criar um novo registo de epi, que abre o formulário de criação do epis.vue (reaproveitando o mesmo formulário para criar e editar).
*/
import IconView from '@/components/UI/IconView.vue';
import EpisView from '@/views/Super/Users/EPIS/epis.vue'
import Obra from '@/api/Obra.js'
import EPIS from '@/api/EPIS.js'
import Funcionario from '@/api/Funcionario.js'
import dayjs from 'dayjs';

export default {
  components: { IconView, EpisView },
  props: {
    has_component: {
      typeof: Boolean,
      default: false
    }
  },
  watch: {
    options: {
      handler() {
        setTimeout(() => { this.searchEPIS() }, 10);
      },
      deep: true,
    },
  },
  beforeCreate() {
    document.title = "ODC - Gestão de EPIs";
  },
  data: () => ({
    obras: [],
    success: false,
    headers: [
      { text: 'Código', sortable: false, value: 'funcionario_codigo' },
      { text: 'Nome', sortable: false, value: 'name' },
      { text: 'Quantidade', sortable: false, value: 'qty' },
      { text: 'Opções', value: 'actions', sortable: false },
    ],
    items: [],
    episDialog: false,
    episDialogLoading: false,
    episDialogUser: null,
    episDialogItems: [],
    obrasById: {}, // cache simples obra_id -> "Codigo - Descricao"
    episById: {},  // cache epi_id -> description
    risksById: {}, // cache risco_id -> "ref - desc"
    total: 0,
    loading: false,
    searching: false,
    tableFooter: {
      'items-per-page-options': [5, 10, 15, 20],
      'items-per-page-text': "Linhas por página"
    },
    options: {},
    filter: { supplier_id: null },
    users_list: [],
    exitDialog: false,
    exitLoading: false,
    exitMenu: false,
    exitFields: {
      id: null,
      data_devolucao: null,
    },
    exitRowIndex: null,
  }),
  computed: {
    crumbs() {
      return [
        { text: 'Dashboard', disabled: false, to: '/admin', exact: true },
        { text: 'Gestão de EPIs', disabled: true, to: window.location.href, exact: true },
      ];
    }
  },
  mounted() {
    if (!this.$store.getters.hasPermission(["super", "epis.read", "epis.give", "epis.write"])) {
      this.$router.push('/forbidden');
    }

    this.loadCaches();
    this.fillBaseData();
  },
  methods: {
    openEpiFormFromDialog(line) {
      // fecha a dialog de listagem
      this.episDialog = false;

      // abre a dialog do EpisView e carrega o EPI completo
      if (this.$refs.episView && this.$refs.episView.openEPI) {
        this.$refs.episView.openEPI({ id: line.id });
      }
    },
    openExitFromDialog(line, index) {
      this.exitRowIndex = index;
      this.exitFields = {
        id: line.id,
        data_devolucao: null,
      };
      this.exitDialog = true;
    },

    async saveExitFromDialog() {
      if (!this.exitFields.id || !this.exitFields.data_devolucao) return;

      try {
        this.exitLoading = true;

        // payload mínimo esperado pelo teu backend (igual ao teu saveExit do epis.vue)
        const payload = {
          id: this.exitFields.id,
          data_devolucao: this.exitFields.data_devolucao,
        };

        await EPIS.registerExit(payload);

        // atualizar a linha no dialog sem refetch
        if (this.exitRowIndex !== null && this.episDialogItems[this.exitRowIndex]) {
          this.$set(this.episDialogItems, this.exitRowIndex, {
            ...this.episDialogItems[this.exitRowIndex],
            data_devolucao: this.exitFields.data_devolucao,
          });
        }

        this.exitDialog = false;
      } catch (e) {
        console.error("Erro ao registar devolução:", e);
      } finally {
        this.exitLoading = false;
      }
    },
    async exportEpi(item) {
      console.log(item)
    },
    async openEpisDialog(row) {
      try {
        this.episDialogUser = row;
        this.episDialog = true;
        this.episDialogLoading = true;
        this.episDialogItems = [];

        // buscar obras do user para mapear obra_id -> "Codigo - Descricao"
        const obrasResp = await Obra.all({tipo: 'O'});
        const obrasList = obrasResp?.data || [];
        this.obrasById = Object.fromEntries(obrasList.map(o => [o.Id, `${o.Codigo} - ${o.Descricao}`]));

        // buscar epis do user
        const resp = await EPIS.getUserEpis(row.Codigo);
        const lines = resp?.data || [];

        // map para a tabela
        this.episDialogItems = lines.map(l => ({
          id: l.id,
          data_entrega: l.data_entrega,
          obra: this.obrasById[l.obra_id] || l.obra_id || "—",
          sharepoint: l.sharepoint || null,
          equipments_count: l.equipments_count || 0,
        }));
      } catch (e) {
        console.error("Erro a carregar EPIs do utilizador:", e);
      } finally {
        this.episDialogLoading = false;
      }
    },
    async loadCaches() {
      const [episResp, risksResp] = await Promise.all([EPIS.all(), EPIS.getRisks()]);
      this.episById = Object.fromEntries((episResp.data || []).map(e => [e.id, e.description]));
      this.risksById = Object.fromEntries((risksResp.data || []).map(r => [r.id, `${r.reference} - ${r.description}`]));
    },
    openAddEpiDialog() {
      if (this.$refs.episView && this.$refs.episView.openCreateFromManagement) {
        this.$refs.episView.openCreateFromManagement();
      }
    },
    getTableDate(date) {
      return date != null ? dayjs(date).toDate().toLocaleDateString() : "-";
    },
    async fillBaseData() {
      this.loading_users = true;
      Funcionario.allNoRestrictions().then(response => {
        this.users_list = response.data.conduril
      });
      const resp = await Obra.all({tipo: 'O'});
      this.obras = resp.data
      
      this.loading_users = false;
      if (this.has_component == false) {
        const key = "suppliers-evaluation-" + this.$store.state.user.id;
        if (localStorage[key] != undefined) {
          let data = JSON.parse(localStorage[key]);
          this.filter = data.filter;
          this.options = data.options;
        }
      }
    },
    searchEPIS(event) {
      if (!!event && event.type == 'submit') this.options.page = 1;

      this.loading = true;

      let filter = { ...this.filter };

      let request = {
        sortBy: this.options.sortBy,
        sortDesc: this.options.sortDesc,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        supplier_id: this.$route.params.id
      };

      Object.assign(request, filter);

      if (this.has_component == false) {
        localStorage["epis-management-" + this.$store.state.user.id] = JSON.stringify({
          filter: this.filter,
          options: this.options,
        });
      }

      EPIS.search(request).then(response => {
        let data = response.data;
        this.total = response.total;
        this.items = data.data.map((item) => {
          this.searching = false;
          return item;
        });
        this.loading = false;
      });
    },

    viewEPI(item) {
      this.$router.push('/super/utilizadores/' + item.user_id + '/epis');
    },
  }
};
</script>

<style scoped>
.eva-page {
  padding-bottom: 32px;
}

.eva-top {
  margin-top: 8px;
}

.eva-breadcrumbs :deep(.v-breadcrumbs__item) {
  font-size: 13px;
}

.eva-titlebar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
}

.eva-title {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.eva-btn {
  border-radius: 12px;
}

.eva-card {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(0,0,0,0.06);
}

.eva-card__title {
  font-weight: 800;
  letter-spacing: 0.2px;
}

.eva-chip {
  border-radius: 999px;
}

.eva-table {
  border-radius: 14px;
  overflow: hidden;
}

.eva-table :deep(thead th) {
  font-weight: 800;
  color: rgba(0,0,0,0.75);
  letter-spacing: 0.2px;
}

.eva-table :deep(tbody tr:hover) {
  background: rgba(0,0,0,0.02);
}

.eva-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-weight: 700;
  color: rgba(0,0,0,0.75);
}

.eva-modal {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(0,0,0,0.06);
}

.eva-input :deep(.v-input__slot) {
  border-radius: 12px !important;
  background: rgba(0,0,0,0.015);
}

.eva-hint {
  margin-top: 8px;
  font-size: 13px;
  color: rgba(0,0,0,0.6);
}
</style>
